import React, { useEffect, useState, useLayoutEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { map } from "lodash";
import { Layout, Menu, Dropdown, Spin } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import RouterList from "./routerList";
import { login, logout, getUserInfo } from "@/actions/auth";
import { Cookie } from "@/utils/cookie";
import Login from "../Login/Login";
import logo from "@/assets/image/logo.png";
import leftlogo from "@/assets/image/leftlogo.png";

import "./index.scss";

const { Header, Content, Footer, Sider } = Layout;

const { pathname } = window.location;

const MenuLayout = ($$) => {
  // 左侧菜单相关参数
  const [collapsed, setCollapsed] = useState(false);
  const [contentLeftMargin, setContentLeftMargin] = useState(262);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState([
    "3",
    "5",
    "8",
    "20",
    "30",
  ]);
  const [selecObj, setSelecObj] = useState<any>("");

  // set selectedKeys and defaultOpenKeys 根据path获取高亮和展开的节点
  const setSelectedNodeInfo = (menuList) => {
    if (menuList && menuList.length > 0) {
      menuList.forEach((item) => {
        if (item.path === pathname && item.type === 1) {
          setSelecObj(item);
          // 防止之前是页面菜单修改成分组菜单后的path脏数据
          setSelectedKeys([`${item.id}`]);
          // setDefaultOpenKeys(item.parentIdList || []);
          return;
        }
        if (pathname.includes(item.path) && item.type === 1) {
          setSelectedKeys([`${item.id}`]);
          // setDefaultOpenKeys(item.parentIdList || []);
          return;
        }
        setSelectedNodeInfo(item.children);
      });
    }
  };

  const toggleSideBar = () => {
    setCollapsed(!collapsed);
    setContentLeftMargin(collapsed ? 262 : 0);
  };

  const pageCompontent = {
    "/login": <Login />,
  };

  // mounted
  useEffect(() => {
    if (Cookie.get("token") && !pageCompontent[pathname]) {
      $$.getUserInfo();
    } else if (!pageCompontent[pathname]) {
      window.location.href = "/login";
    } else {
      // do
    }
  }, []);

  // listen menuList data
  useEffect(() => {
    if (pathname === "/envconfig") {
      setSelecObj({ title: "环境配置" });
      setSelectedKeys([`envconfig`]);
      return;
    }
    if ($$.menuList.length > 0) {
      // set active node and open nodes
      setSelectedNodeInfo($$.menuList);
    }
  }, [$$.menuList]);

  const onUserActionClick = (key) => {
    switch (key) {
      case "logout":
        $$.logout();
        break;
      default:
        break;
    }
  };

  const onMenuItemClick = (id, parentIdList, path, type, obj) => {
    // type - 菜单类型
    const { history } = $$;

    if (window.location.pathname === path) return;

    // 如果点击分组菜单-不跳转
    if (type === 3) return;
    setSelecObj(obj);
    history.push(path);

    setSelectedKeys([`${id}`]);
    setDefaultOpenKeys(parentIdList || []);

    // 解决内部跳转 点击菜单返回主页问题
    if (window.location.pathname.indexOf(path) === 0) {
      history.push("/");
      setTimeout(() => {
        history.replace(path);
      });
    }
  };

  const renderUserAction = () => {
    const { userName, invitationCode } = $$;
    console.log($$);
    const items: MenuProps["items"] = [
      {
        key: "1",
        label: <div onClick={() => onUserActionClick("logout")}>退出登录</div>,
      },
    ];

    return (
      <div className="user-view">
        <Dropdown menu={{ items }} trigger={["click"]}>
          <span className="user-action">
            <img src={logo} alt="" />
            <span>{userName || "***"} </span>
            <span>{`(${$$.email})`}</span>
          </span>
        </Dropdown>
      </div>
    );
  };

  const renderMenuList = (menuList) => {
    return map(menuList, (m) => {
      if (m.subMenu.length === 0) {
        return (
          <Menu.Item
            key={m.id}
            onClick={() =>
              onMenuItemClick(m.id, m.parentIdList, m.path, m.type, m)
            }
          >
            {m.selectedIcon && m.unselectedIcon ? (
              <div className="anticon menu-icon">
                <div className="menu-img">
                  <img
                    src={
                      selectedKeys.indexOf(String(m.id)) === -1
                        ? m.unselectedIcon
                        : m.selectedIcon
                    }
                    alt=""
                  />
                </div>
              </div>
            ) : null}
            <span>{m.title}</span>
          </Menu.Item>
        );
      }

      return (
        <Menu.SubMenu
          key={m.id}
          title={
            <span>
              {(m.icon || m.selectedIcon || m.unselectedIcon) && !m.parentId ? (
                <div className="anticon menu-icon">
                  <div className="menu-img">
                    <img
                      src={m.unselectedIcon ? m.unselectedIcon : m.selectedIcon}
                      alt=""
                    />
                    <img
                      src={m.selectedIcon ? m.selectedIcon : m.unselectedIcon}
                      alt=""
                    />
                  </div>
                </div>
              ) : null}
              <span style={{ color: "#7b8495", fontSize: "14px" }}>
                {m.title}
              </span>
            </span>
          }
        >
          {renderMenuList(m.subMenu)}
        </Menu.SubMenu>
      );
    });
  };

  const { menuList, location, systemLoading } = $$;

  if (systemLoading && pathname !== "/login") {
    return (
      <div className="system-loading-wrapper">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {pageCompontent[pathname] ? (
        pageCompontent[pathname]
      ) : (
        <Layout
          className={`menu-layout ${
            location.pathname.split("/").length > 0
              ? location.pathname.split("/")[1]
              : ""
          }`}
        >
          <Sider
            className="sidebar"
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={262}
            collapsedWidth={0}
          >
            <div className="logo-wrapper">
              <img src={leftlogo} alt="" />
            </div>

            <Menu
              // theme="dark"
              style={{ height: "calc(100% - 130px)" }}
              mode="inline"
              defaultOpenKeys={defaultOpenKeys}
              selectedKeys={selectedKeys}
            >
              {renderMenuList(menuList)}
            </Menu>
          </Sider>

          <Layout
            className="right-section"
            style={{ marginLeft: contentLeftMargin }}
          >
            <Header className="header">
              <div className="headerLeft">
                <div onClick={toggleSideBar}>
                  {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </div>

                <span className="title">{selecObj.title || selecObj.name}</span>
              </div>

              {renderUserAction()}
            </Header>

            <Content className="npm-package-content">
              <RouterList
                userId={$$.userId}
                userName={$$.userName}
                length={$$.menuList.length}
                menuList={$$.menuList}
                history={$$.history}
              />
            </Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { userName, userId, menuList, systemLoading, invitationCode, email } =
    state.auth;
  return {
    userName,
    userId,
    menuList,
    systemLoading,
    invitationCode,
    email,
  };
};

export default withRouter(
  connect(mapStateToProps, { login, logout, getUserInfo })(MenuLayout)
);
